import React from 'react';
import ReactDOM from 'react-dom';
import EventBus from '../../utils/EventBus';
import styles from './Toast.module.css';

let _id = 0;

const ICONS = { success: 'check_circle', error: 'cancel', warning: 'warning', info: 'info' };

class Toast extends React.Component {
  constructor(props) {
    super(props);
    this.state = { toasts: [] };
    this._handleToast = this._handleToast.bind(this);
  }

  componentDidMount() {
    EventBus.on('toast', this._handleToast);
  }

  componentWillUnmount() {
    EventBus.off('toast', this._handleToast);
  }

  _handleToast({ message, type = 'info', duration = 3500 }) {
    const id = ++_id;
    this.setState(s => ({ toasts: [...s.toasts, { id, message, type }] }));
    setTimeout(() => this._dismiss(id), duration);
  }

  _dismiss(id) {
    this.setState(s => ({ toasts: s.toasts.filter(t => t.id !== id) }));
  }

  render() {
    const { toasts } = this.state;
    if (!toasts.length) return null;

    return ReactDOM.createPortal(
      <div className={styles.container}>
        {toasts.map(t => (
          <div key={t.id} className={[styles.toast, styles[t.type]].join(' ')}>
            <span className={'material-symbols-rounded ' + styles.icon} style={{ fontSize: 16 }}>
              {ICONS[t.type] || ICONS.info}
            </span>
            <span className={styles.message}>{t.message}</span>
            <button className={styles.close} onClick={() => this._dismiss(t.id)}>
              <span className="material-symbols-rounded" style={{ fontSize: 14 }}>close</span>
            </button>
          </div>
        ))}
      </div>,
      document.body
    );
  }
}

export default Toast;
